import { css } from 'linaria';

export const seoDescriptionStyle = css`
  margin: var(--space-200) 0 var(--space-450);
  font-size: 12px;
  line-height: 20px;
  color: var(--text-minor);
`;
